// Generated by CoffeeScript 2.3.2

import Button from '@material-ui/core/Button';
import CurrentState from './CurrentState'
import Divider from '@material-ui/core/Divider'
import React from 'react';
import TopBar from './TopBar'
;
var MainView;

MainView = function(props) {
  var app, configurationId, showAccuseDialog, showCommlinkDialog, showHandDialog, showShowDialog, showSuggestDialog, solver;
  ({configurationId, solver, app} = props);
  ({showHandDialog, showSuggestDialog, showShowDialog, showAccuseDialog, showCommlinkDialog} = app);
  return <div className="MainView">
    <TopBar app={app} />
    {(solver != null ? <div>
          <Button variant="contained" color="primary" onClick={showHandDialog}> Hand </Button>
          <Button variant="contained" color="primary" onClick={showSuggestDialog}> Suggest </Button>
          <Button variant="contained" color="primary" onClick={showShowDialog}> Show </Button>
          <Button variant="contained" color="primary" onClick={showAccuseDialog}> Accuse </Button>
          {(configurationId === "star_wars" ? <Button variant="contained" color="primary" onClick={showCommlinkDialog}> 
                Commlink 
              </Button> : void 0)}
          <Divider />
          <CurrentState solver={solver} app={app} /> 
        </div> : void 0)}
  </div>;
};

export default MainView;
